import { render, staticRenderFns } from "./WesternMedicineList.vue?vue&type=template&id=4a80ce5d&scoped=true"
import script from "./WesternMedicineList.vue?vue&type=script&lang=js"
export * from "./WesternMedicineList.vue?vue&type=script&lang=js"
import style0 from "./WesternMedicineList.vue?vue&type=style&index=0&id=4a80ce5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a80ce5d",
  null
  
)

export default component.exports